import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../Auth/firebase.init';
import { Spin } from 'antd';
import { allowedEmails } from '../Blog/AllBlog';

const AdminRoute = ({ children }) => {
    const [user, loading] = useAuthState(auth);
    if (loading) {
        return <Spin size="large" fullscreen />
    }
    else if (allowedEmails.includes(user?.email)) {
        return children;
    }
    else {
        return <div className='text-center text-2xl text-red-500 w-full py-20'>Access Denied</div>;
    }
};

export default AdminRoute;